export default "__VITE_ASSET__DckgW7S9__"